<div class="unbookable-shop-info" [class.text-danger]="!map">
  <app-icon name="stop" class="mr-2" />
  @switch (reason.type) {
    @case ('beforeSeason') {
      {{
        'UNBOOKABLE.unbookableInfoBeforeSeason'
          | alpitranslate
            : {
                season_start: reason.start | date: ('UNBOOKABLE.unbookableInfoDateFormat' | alpitranslate)
              }
      }}
    }
    @case ('afterSeason') {
      {{
        'UNBOOKABLE.unbookableInfoAfterSeason'
          | alpitranslate
            : {
                season_end: reason.end | date: ('UNBOOKABLE.unbookableInfoDateFormat' | alpitranslate)
              }
      }}
    }
    @case ('pause') {
      {{
        'UNBOOKABLE.unbookableInfoPause'
          | alpitranslate
            : {
                pause_start: reason.start | date: ('UNBOOKABLE.unbookableInfoDateFormat' | alpitranslate),
                pause_end: reason.end | date: ('UNBOOKABLE.unbookableInfoDateFormat' | alpitranslate)
              }
      }}
    }
    @case ('minimumDuration') {
      {{ 'UNBOOKABLE.unbookableInfoMinDuration' | alpitranslate: { min_duration: reason.minDuration } }}
    }
    @case ('maximumDuration') {
      {{ 'UNBOOKABLE.unbookableInfoMaxDuration' | alpitranslate: { max_duration: reason.maxDuration } }}
    }
    @case ('minimumDelay') {
      {{ 'UNBOOKABLE.unbookableInfoMinDelayInvalid' | alpitranslate: { min_delay: reason.minDelay } }}
    }
    @case ('negativeMinimumDelay') {
      {{ 'UNBOOKABLE.unbookableInfoNegativeMinDelayInvalid' | alpitranslate: { min_delay: reason.minDelay } }}
    }
    @case ('unservableAges') {
      {{ 'UNBOOKABLE.unbookableInfoUnservableAges' | alpitranslate: { age: reason.age } }}
    }
  }
</div>
